module.exports = __webpack_public_path__ + "images/bannerEN-3757974e6aee93e6719c0b5a892c08b3.png";